/**
 * @generated SignedSource<<1abb51d69802c42f4852b063be9cbbba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthReason = "BAD_LEVEL" | "CREDENTIALS_REFUSED" | "INVALID_EMAIL" | "LINK_REFUSED" | "NAME_REQUIRED" | "NAME_TOO_LONG" | "NATIVE_LANGUAGE_IS_ENGLISH" | "PASSWORD_REFUSED" | "RESET_REQUESTED" | "SIGNUP_ACCEPTED" | "WEAK_PASSWORD" | "%future added value";
export type LinkViewConfirmResetMutation$variables = {
  password: string;
  token: string;
};
export type LinkViewConfirmResetMutation$data = {
  readonly confirmPasswordReset: {
    readonly ok: boolean;
    readonly reason: AuthReason | null | undefined;
  };
};
export type LinkViewConfirmResetMutation = {
  response: LinkViewConfirmResetMutation$data;
  variables: LinkViewConfirmResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "password"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "ConfirmPasswordResetPayload",
    "kind": "LinkedField",
    "name": "confirmPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkViewConfirmResetMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "LinkViewConfirmResetMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "8ecf94ca3d95873d5c658435f080ad59",
    "id": null,
    "metadata": {},
    "name": "LinkViewConfirmResetMutation",
    "operationKind": "mutation",
    "text": "mutation LinkViewConfirmResetMutation(\n  $token: String!\n  $password: String!\n) {\n  confirmPasswordReset(token: $token, password: $password) {\n    ok\n    reason\n  }\n}\n"
  }
};
})();

(node as any).hash = "2759a1d7fb52c81fed1105547b9f856c";

export default node;
